import { AnnouncementDetail } from './AnnouncementDetail';
export default AnnouncementDetail;
